import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  return <section className="relative bg-navy-900 text-text-light pt-20 pb-24 px-4 sm:px-6 lg:px-8 overflow-hidden" data-id="element-80">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-full bg-navy-800/50 blur-3xl rounded-full pointer-events-none" data-id="element-81" />

      <div className="relative max-w-7xl mx-auto" data-id="element-82">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-83">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="max-w-2xl" data-id="element-84">
            <motion.h1 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            delay: 0.2
          }} className="text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight mb-6 text-balance" data-id="element-85">
              Deja de ser la &quot;Secretaria Gratuita&quot; de tus prospectos y
              convi&eacute;rtete en una{' '}
              <span className="text-gold-500" data-id="element-86">M&aacute;quina de Cierre</span> en
              WhatsApp.
            </motion.h1>

            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            delay: 0.4
          }} className="text-lg sm:text-xl text-cream-100/90 font-sans font-light leading-relaxed mb-8 border-l-2 border-gold-500 pl-4" data-id="element-87">
              El Sistema IM&Aacute;N: El m&eacute;todo &eacute;tico de 3 pasos
              dise&ntilde;ado para mujeres 45+ que venden seguros, salud,
              nutrici&oacute;n y autos en USA sin tener que perseguir a nadie.
            </motion.h2>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            delay: 0.6
          }} className="space-y-6" data-id="element-88">
              <div className="pb-2" data-id="element-89">
                <a href="#oferta" className="inline-flex items-center justify-center gap-2 bg-gold-500 hover:bg-gold-600 text-navy-900 font-bold text-lg px-8 py-4 rounded-lg transition-all duration-300 hover:scale-105 hover:shadow-[0_0_20px_rgba(201,168,76,0.3)] w-full sm:w-auto" data-id="element-90">
                  QUIERO SER UN IM&Aacute;N DE VENTAS AHORA
                  <ArrowRight className="w-5 h-5" data-id="element-91" />
                </a>
              </div>
              <p className="text-base sm:text-lg text-cream-100/80 leading-relaxed" data-id="element-92">
                Son las 9:00 PM. Est&aacute;s agotada. Has pasado todo el
                d&iacute;a contestando &quot;Info y Precio&quot; en WhatsApp,
                enviando PDFs y audios explicativos, solo para recibir el mismo
                resultado de siempre: las dos flechitas azules del
                &quot;visto&quot;.
              </p>
              <p className="text-base sm:text-lg text-cream-100/80 leading-relaxed" data-id="element-93">
                Sientes que trabajas mucho, pero tu cuenta bancaria no se mueve.
                Peor a&uacute;n: sientes que est&aacute;s rogando por
                atenci&oacute;n y perdiendo tu dignidad frente a desconocidos
                que solo te hacen perder el tiempo.
              </p>
            </motion.div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.4,
          ease: 'easeOut'
        }} className="relative lg:ml-auto w-full max-w-lg mx-auto lg:max-w-none" data-id="element-94">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl border border-gold-500/20" data-id="element-95">
              <div className="absolute inset-0 bg-gradient-to-tr from-navy-900/40 to-transparent z-10" data-id="element-96" />
              <img src="https://cdn.magicpatterns.com/uploads/9rHJntopgmQZzgMiTYLkE4/Escena_de_oficina_elegante_y_moderna.png" alt="Vender Sin Perseguir - Sistema IMAN" className="w-full h-auto object-cover" data-id="element-97" />
            </div>
            <div className="absolute -bottom-6 -left-6 w-24 h-24 bg-gold-500/10 rounded-full blur-2xl" data-id="element-98" />
            <div className="absolute -top-6 -right-6 w-32 h-32 bg-navy-800 rounded-full blur-2xl -z-10" data-id="element-99" />
          </motion.div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold-500/50 to-transparent" data-id="element-100" />
    </section>;
}